export default {
    'zh-CN': {
        test: '测试',
        title: '标题',
        message: '讯息',
        langCode: '语言',
        desc: '描述',
        createdAt: '建立时间',
        updatedAt: '最後更新',
        contentType: '内容类型',
        logout: '登出',
        add: '新增',
        edit: '修改',
        trash: '删除',
        deleteSelected: '删除勾选',
        selected: '选择',
        agreeSelected: '通过 user',
        publish: '上架',
        unpublish: '下架',
        clear: '清除',
        submit: '送出',
        typeContent: '故事',
        typeDecoration: '饰品',
        typeApplication: '应用',
        filterBy: '以 {column} 过滤',
        defaultOption: '选 {column}',
        bundle: '包',
        goods: '商品',
        content: '故事',
        decoration: '饰品',
        isBundle: '故事集',
        descGoodsBundle: '商品组合',
        descBuildBundle: '建立故事集',
        decorationBundle: '饰品包',
        buyOnMarket: '可购买',
        store: '商城',
        theater: '剧院',
        isStoreOrTheater: '给商城或剧院',
        yes: '是',
        no: '否',
        wishSelf: '自选',
        wishStoryContent: '故事内容',
        wishStoryVolume: '故事专辑',
        wishStoryGoods: '故事商品',
        wishDecorationGoods: '饰品商品',
        wishDecorationBundle: '饰品包',
        sort: '排序',
        sortAsc: '正序',
        sortDesc: '倒序',
        category: '类别',
        channel: '频道',
        tag: '标签',
        appType: 'app 类型',
        preload: '预载',
        market: '市场',
        size: '下载档案大小',
        time: '时间',
        episode: '集数',
        priority: '优先顺序',
        status: '状态',
        publishBeginDate: '上架日期',
        publishBeginTime: '上架时间',
        publishEndDate: '下架日期',
        publishEndTime: '下架时间',
        downloadUrl: '下载连结',
        bannerUrl: 'banner 连结',
        imageUrl: '图片连结',
        previewImageUrl: '预览图片连结',
        previewDownloadUrl: '预览下载连结',
        creator: '建立者',
        currency: '币别',
        price: '金额',
        version: '版本',
        success: '成功',
        playCount: '播放次数',
        sellCount: '销售次数',
        commentRank: '评分',
        commentCount: '评分次数',
        flag: 'flag',
        order: 'order',
        typeZHCN: '简体中文',
        typeZHTW: '繁体中文',
        typeEN: '英文',
        descTheaterDetail: '剧院的细节',
        descStoreDetail: '商城的细节',
        descImageUrl: '内页图片',
        descPreviewImageUrl: '封面图片',
        exampleTime: '(30:20 代表档案时间为30分20秒)',
        exampleEpisode: '(代表是第x集，例如 2 代表第二集)',
        noPublishEnd: '不下架',
        required: '必填',
        minValue: '最少',
        minLength: '长度不足',
        all: '全部',
        unPublishMessage: '确定要下架 ?',
        deleteMessage: '确定要删除 ?',
        syncMessage: '确定要同步 ?',
        publishMessage: '确定要上架 ?',
        errorMessage: '发生错误',
        confirmMessage: '确定',
        type: '类型',
        typeStar: '优质',
        typeSell: '必备',
        typeRecommend: '主打星',
        descMenuUserList: '使用者列表',
        descMenuMessageList: '讯息列表',
        descMenuAppList: 'APP 列表',
        descMenuFileList: '档案列表',
        descMenuSdkFileList: 'SDK 列表',
        descMenuSampleFileList: 'Sample Code 列表',
        descMenuAdminGoodsList: '商品列表',
        descMenuDashboard: '仪表板',
        descMenuReport: '报表列表',
        descMenuRecommendList: '推荐列表',
        descMenuFeedbackList: '商城 feedback 列表',
        descMenuOrderList: '订单列表',
        descMenuCategoryList: '类别列表',
        descMenuChannelList: '频道列表',
        descMenuTagList: '标签列表',
        descMenuMarketList: '市场列表',
        descMenuHotList: '商城首页列表',
        descMenuMiboNewsList: 'Mibo News 列表',
        descMenuMiboPetVersionList: 'Mibo pet 版本列表',
        descMenuGoodsList: '商品列表',
        descSync: '同步',
        descPublish: '上架',
        descPetRefreshInterval: '每 30 秒更新此页面',
        descMenuMotionFileList: 'Motion 列表',
        descMenuMotionCategoryList: 'Motion 类别列表',
        descMenuMotionTagList: 'Motion 标签列表',
        descMenuResourceDescription: 'Introduction',
        descMenuRobotSdk: 'NUWA Robot SDK',
        containThisContent: '包含此故事',
        uploading: '上传中',
        email: '邮箱',
        invalidEmailFormat: '邮箱格式不正确',
        duplicateEmail: '您输入的邮箱已存在',
        password: '密码',
        confirmPassword: '确认密码',
        phone: '电话',
        companyName: '公司名称',
        sameAsPassword: '两次密码输入不一致',
        package: 'package',
        keyName: 'key 名称',
        platform: '服务平台',
        publishSecret: '发布版安全码 SHA1',
        testSecret: '测试版安全码 SHA1',
        appId: 'app Id',
        appKey: 'app key',
        expire: '过期时间',
        wantMessage: '希望收到 mail ?',
        indexProduct: '产品介绍',
        indexNews: '最新消息',
        indexResource: '资源中心',
        indexSDK: 'SDK',
        indexForum: '技术讨论区',
        indexDoc: 'Doc',
        indexMotion: 'Motion',
        indexSampleCode: 'Sample Code',
        indexRegister: '注册',
        indexLogin: '登入',
        indexControlPanel: '控制台',
        registerTitle: '成为开发者',
        registerFillInfo: '填写帐号讯息',
        registerComplete: '完善开发者讯息',
        registerFinish: '注册完成',
        registerFinishMessage: '等待管理员审核中，请注意邮箱',
        addApp: '增加 APP',
        editApp: '修改 App',
        motionName: '动作名称',
        motionDescription: '动作描述',
        keyword: '关键字',
        descAddI18n: '增加语言',
        // [首页]
        buy_now: '立刻购买',
        language: '语言',
        developer_banner_title_01: '实现你的丰富想像',
        developer_banner_text_01: '透过女娲机器人，让你的应用走入人们的生活',
        developer_feature_step_title: '开发我的小丹应用',
        developer_feature_step_text: '透过以下步骤，推出你的服务',
        developer_feature_support_title: '技术支持',
        developer_banner_buy: '还没拥有自己的女娲机器人吗？',
        developer_documentation_download: '下载',
        developer_documentation_sdk: '女娲机器人SDK',
        developer_feature_step_store: '商城发布',
        developer_feature_step_description_store: '商品上架，广泛的小丹用户可以开始使用你的商品',
        developer_feature_step_product: '产品验证',
        developer_feature_step_description_product: '提交专案后，Nuwa 将针对应用内容及程式进行审核，以确保符合规范',
        developer_feature_step_creat: '创建与开发',
        developer_feature_step_description_creat: '根据应用类型创建不同专案，分别为应用程式、故事及饰品',
        developer_feature_step_sign: '登录开发者',
        developer_feature_step_description_sign: '注册帐号，认证开发者以开通功能',
        developer_feature_tool_ai: '生动语音人工智能',
        developer_feature_tool_description_ai: '女娲机器人搭载小爱同学，能快速应用小爱同学强大的语音辨识、自然语言处理及丰富的语音能力',
        developer_feature_tool_motion: '自由的肢体表现',
        developer_feature_tool_description_motion: '内建MCU微型控制器，支持360°旋转运动,可以实现多角度关节动作，拥有更多可能性',
        developer_feature_tool_devtool: '便利的开发工具',
        developer_feature_tool_description_devtool: '目前提供动作套件，方便应用。未来将陆续推出内容开发及程式开发的多样工具',
        developer_banner_store_title: '女娲商城让您接触到更多拥有女娲机器人的家庭。',
        developer_banner_store_text: '您能开发应用程式、故事、饰品等商品。并且，您的创意将被遍布全国的孩子们使用。',
        developer_distribute_plan_title: '女娲开发者计划',
        developer_distribute_plan_text: '基于女娲拥有的丰富软件技术，帮助开发者们快速发展应用程式及内容。',
        developer_distribute_plan03_title: '订制化开发合作伙伴',
        developer_distribute_plan03_text: '与女娲协作开发，获取更多资源。我们将进阶提供 Unity SDK、更新服务，让您的机器人的环境及软件等能整体客制化更新。透过我们的更新服务，您将省下大量时间、精力及费用，即能创造您独一无二的机器人。',
        developer_distribute_plan02_title: '进阶开发合作伙伴',
        developer_distribute_plan02_text: '除了能自由在商城推出您的 app 之外，您还能再开发阶段使用女娲提供的模拟器。透过模拟器，即使机器人不在身边，您可以拥有机器人环境，继续创造、优化您的 app。',
        developer_distribute_plan01_title: '平台开发者计划',
        developer_distribute_plan01_text: '通过适用于女娲机器人的商城向全国用户推出您的 app。您还可以获取 测试工具、开发文件以及 app 分析。利用 Nuwa Developer Console 上的 App 分析来衡量您的用户参与情况和收入状况，且此分析无需额外技术性的编程配合。',
        developer_distribute_plan_update: '更新',
        developer_distribute_plan_unity: '统一SDK',
        developer_distribute_plan_store: '商城上架',
        developer_distribute_plan_tool: '內容及开发工具',
        developer_distribute_plan_doc: '开发文件',
        developer_distribute_plan_sdk: '下载SDK',
        developer_banner_rule_title: '准则与资源',
        developer_banner_rule_text: '阅读设计与开发的规范，了解如何提交与行销您的应用。',
        developer_documataion_overview_00_title: '机器人开发文件',
        developer_documataion_overview_01_title: '简介',
        developer_documataion_overview_02_title: '应用程式如何在机器人上运作？',
        developer_documataion_overview_01_text: '女娲开发者平台让您能增加、延伸女娲机器人上的功能。用户可以透过对话来学习、玩游戏或达到其他目的。身为开发者的您，可以利用平台上提供的文件及工具串连您的第三方服务，为用户创造令人开心的使用经验。',
        developer_documataion_overview_02_text: '当你计划开发了女娲机器人的应用程式，你将会设计一个声音、视觉交互应用或是结合两者的服务。透过声音或视觉，用户能更清楚快速了解您的内容。当用户和您的应用程式对话时，过程将在云端运行。',
        // [账号]
        select_category: '请选择一个种类',
        countries: '中国',
        company_job_information: '您的机构或公司资讯',
        basic_information: '基本信息',
        submit_info: '提交',
        write_plan: '写下你的计划...',
        proceed: '下一步',
        individual_developer: '个人开发者',
        enterprise_developer: '企业开发者',
        enter_email: '请输入邮箱',
        empty_mailbox: '邮箱或者密码不能为空',
        creat_nuwa_account: '建立女娲开发者帐号',
        developer_account_remember_me: '记住我',
        developer_account_forget_password: '忘记密码',
        developer_account_join_developer: '加入女娲开发者？',
        developer_account_password_warning: '密码需包含 8-16 个字，并包含英文和数字',
        developer_account_privacy: '当您注册此帐号时，即表示您已阅读、了解并同意接受用户协议与隐私条款。',
        developer_account_have_account: '已拥有账户？',
        developer_account_forget_password_mail: '输入您的电子邮箱来重设密码',
        developer_account_forget_mail: '如果你忘记了你的电子邮件，你可以查一下。',
        developer_account_active_mail: '就快完成啰！请验证您的帐户验证信件已经寄到下方的邮箱内',
        developer_account_active_mail_click: '点击邮箱内的认证信件来开通您的帐户！',
        developer_account_not_get_mail: '尚未收到认证信？',
        developer_account_account_setup_complete: '账号验证成功！',
        developer_account_setup_log: '你可以此邮箱作为女娲开发者的登入帐号',
        developer_account_enter_incorrectly: '账号或密码输入错误',
        developer_account_description: '选择您的账户类别',
        developer_account_description_warning: '创建帐号后不得更改帐号类别',
        developer_account_information_real_name: '真实姓名',
        developer_account_information_id: '开发者代号',
        developer_account_information_country: '国家/地区',
        developer_account_information_company_name: '公司名称',
        developer_account_information_category: '企业类别',
        developer_account_information_company_scale: '公司规模',
        developer_account_information_job_title: '您的职位',
        developer_account_information_website: '公司网站',
        developer_account_information_develop_plan_title: '开发计划',
        developer_account_information_develop_plan_text: '请与我们分享您想开发的应用。您的目标是什么？您想提供什么类型的服务？',
        // [header]
        developmentPlan: '开发计划',
        file: '文件',
        discuss: '讨论',
        blog: '博客',
        login: '登录',
        loginOut: '登出',
        loginUser: '用户',
        introductionPlatform: '平台简介',
        developmentProcess: '开发流程',
        rulesDocument: '规则文档',
        getStarted: '开始',
        instructionsSdk: 'SDK 说明',
        actionListDescription: '动作清单说明',
        nuwaEnterpriseIdentification: 'Nuwa 企业识别',
        dannyEnterpriseIdentification: 'Danny 企业识别',
        console: '控制台',
        myConsole: '我的控制台',
        technicalSupportSdk: '简单易用的SDK让您能快速获 Nuwa 技术并调用至您的 Android studio 或 Unity IDE',
        technicalSupportMotion: '查看能直接应用到专案中的机器人动作套件',
        technicalSupportAction: '动作列表',
        loginError: '您的ID或密码输入错误',
        serverAppears: '服务器或网络连接错误',
        resources: '资源',
        support: '支援',
        aboutNuwa: '关于钕娲',
        designGuideilnes: '设计理念',
        nuwaRobotSDK: '钕娲机器人SDK',
        motionList: '动作清单',
        forums: '论坛',
        bugReport: '回报错误',
        contactUs: '联系我们',
        nuwaHompage: '钕娲首页',
        jobOpportunities: '加入我们',
        buyNUWARobot: '购买机器人',
        termsAndAgreements: '协议条款',
        privacyPolicy: '隐私政策',
        // 新增
        homePageFileDocumentationSdkNullTop: '你似乎还没登入喔！',
        homePageFileDocumentationSdkNullBot: '请先登入才能观看下载！',
        homePageIntroducesHeaderStoreTop: '女娲商城让您接触到更多拥有女娲机器人的家庭',
        homePageIntroducesHeaderchildTop: '您能开发应用程式、故事、饰品等商品',
        homePageIntroducesHeaderchildBot: '并且，您的创意将被遍布全国的孩子们使用',
        homePageIntroducesContentPlan: '女娲开发者计划',
        homePageIntroducesContentPlanBot: '基于女娲拥有的丰富软件技术，帮助开发者们快速发展应用程式及内容',
        homePageIntroducesContentPlatform: '平台开发者计划',
        homePageIntroducesContentPlatformContOne: '通过适用于女娲机器人的商城向全国用户推出您的 app',
        homePageIntroducesContentPlatformContTwo: '您还可以获取测试工具、开发文件以及 app 分析',
        homePageIntroducesContentPlatformContThree: '利用 Nuwa Developer Console 上的 App 分析来衡量您的用户参与情况和收入状况，且此分析无需额外',
        homePageIntroducesContentPlatformContFour: '技术性的编程配合',
        homePageIntroducesContentAdvanced: '进阶开发合作伙伴',
        homePageIntroducesContentAdvancedContOne: '除了能自由在商城推出您的 app 之外，您还能再开发阶段使用女娲',
        homePageIntroducesContentAdvancedContTwo: '提供的模拟器',
        homePageIntroducesContentAdvancedContThree: '透过模拟器，即使机器人不在身边，您可以拥有机器人环境，继续',
        homePageIntroducesContentAdvancedContFour: '创造、优化您的 app',
        homePageIntroducesContentCustomized: '客制化开发合作伙伴',
        homePageIntroducesContentCustomizedContOne: '与女娲协作开发，获取更多资源。我们将进阶提供 Unity SDK、更',
        homePageIntroducesContentCustomizedContTwo: '新服务，让您的机器人的环境及软件等能整体客制化更新',
        homePageIntroducesContentCustomizedContThree: '透过我们的更新服务，您将省下大量时间、精力及费用，即能创造',
        homePageIntroducesContentCustomizedContFour: '您独一无二的机器人',
        homePageIntroducesBottomGuidelines: '准则与资源',
        homePageIntroducesBottomAbout: '阅读设计与开发的规范，了解如何提交与行销您的应用。',
        homePageIntroducesBottomWatch: '查看规范与资源',
        platformDeveloperProgram: '通过适用于女娲机器人的商城向全国用户推出您的 app，您还可以获取测试工具、开发文件以及 app 分析，利用 Nuwa Developer Console 上的 App 分析来衡量您的用户参与情况和收入状况，且此分析无需额外技术性的编程配合。',
        AdvancedPevelopmentPartners: '除了能自由在商城推出您的 app 之外，您还能再开发阶段使用女娲提供的模拟器，透过模拟器，即使机器人不在身边，您可以拥有机器人环境，继续创造、优化您的 app。',
        customDevelopmentPartners: '与女娲协作开发，获取更多资源。我们将进阶提供 Unity SDK、更新服务，让您的机器人的环境及软件等能整体客制化更新，透过我们的更新服务，您将省下大量时间、精力及费用，即能创造您独一无二的机器人。'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/zhCN.js